import b from 'b_';
import cx from 'classnames';
import React from 'react';

import './detailed-view__header.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
    isHeadless?: boolean;
    mix?: string;
}

export const LessonViewDetailedViewHeader = React.forwardRef(({ children, isHeadless, mix }: Props) => {
    return (
        <div className={cx(b('detailed-view', 'header', { headless: isHeadless }), mix)}>{!isHeadless && children}</div>
    );
});
